import { useEffect, useState } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRouter } from "../useRouter";
import { applyCheckPromotionCode, getCashUserStatus } from "src/service/pay";
import { useSetRecoilState, useRecoilValue } from "recoil";
import {
  close30dGuideAtom,
  isShowPayAtom,
  navStepAtom,
  productKeyAtom,
} from "src/atoms";
import { serviceEndTimeFormat } from "src/utils/dateManagement";
import { notifyError } from "src/components/Common/Toast";
import { useIsOciProduct } from "../recoil/useIsOciProduct";
import { useIsDspProduct } from "../recoil/useIsDspProduct";
import dayjs from "dayjs";
import { useProvisioningPoll } from "./console/useProvisioningPoll";
import { IGetUnregisterBillRes } from "src/service/types/pay.type";

interface IUseCheckConsoleProps {
  isMyServiceLoading: boolean;
  unregisterPay: IGetUnregisterBillRes[]; // 프로모션 결제 안된 경우
  unregisterPromotion: IGetUnregisterBillRes[]; // 프로모션 결제 안된 경우
  setShowSiteNewModal: (show: boolean) => void; // 사이트 생성 모달 토글
  serviceList: any; // 서비스 리스트
  setMakeType: any; // 사이트 생성 타입
  setDoNotOpenGuide: any; // 30일 가이드 미열기 토글
  setServiceNotice: any; // 서비스 공지사항
  setCreatePercent: any; // 프로모션 생성 퍼센트
  detailIndex: number; // 서비스 인덱스 (현재는 eCo의 경우에만 해당 추후 viewType -> list 개발 시 사용)
  setShowMsgModal: (show: boolean) => void; // 메시지 모달 토글
  setIsDone: (isDone: boolean) => void; // 완료 토글
}
// 콘솔에서 초기값 세팅하는 Hook
export function useCheckConsole({
  isMyServiceLoading,
  unregisterPay,
  unregisterPromotion,
  serviceList,
  setShowSiteNewModal,
  setMakeType,
  setDoNotOpenGuide,
  setServiceNotice,
  setCreatePercent,
  detailIndex,
  setShowMsgModal,
  setIsDone,
}: IUseCheckConsoleProps) {
  const route = useRouter();
  const setIsShowPay = useSetRecoilState(isShowPayAtom);
  const setNavStep = useSetRecoilState(navStepAtom);
  const productKey = useRecoilValue(productKeyAtom);
  const close30dGuide = useRecoilValue(close30dGuideAtom);
  const { isOciProduct } = useIsOciProduct();
  const { isDspProduct } = useIsDspProduct();
  const serviceEndTime = serviceEndTimeFormat(serviceList[0]?.serviceEndTime);
  const subscriptionEndDate = dayjs(serviceList[0]?.subscriptionEndDate)
    .add(1, "day")
    .format("YYYY-MM-DD");
  // const { isDsfProduct } = useIsDsfProduct();
  // const { applyCheckPromotionCodeList } = useApplyCheckPromotionCode({});
  const [pollTargetUid, setPollTargetUid] = useState("");
  // 폴링 훅: 최상위에서 구독. 상태로 대상 UID를 제어
  useProvisioningPoll({
    serviceUid: pollTargetUid,
    onProgress: (status, percent) => {
      setServiceNotice(status);
      setCreatePercent(percent);
    },
    onComplete: () => {
      setServiceNotice("");
      setCreatePercent(0);
      setShowMsgModal(true);
    },
  });

  useEffect(() => {
    const init = async () => {
      // product값이 없는경우
      if (!sessionStorage.getItem("product")) {
        route.goLogin();
        return;
      }
      // console.log("fsdjklfjsdlkfjsdklf!@#!@#!@");
      //현금 결제인지 확인
      const checkCashStatus = await getCashUserStatus({
        product: [getProductFromSessionStorage()],
      });
      console.log("checkCashStatus", checkCashStatus);
      console.log("serviceList", serviceList);
      if (
        (serviceList?.payCompany === "CASH" &&
          checkCashStatus &&
          checkCashStatus.status === "WAIT") ||
        (checkCashStatus.serviceUid === "" &&
          checkCashStatus.status === "APPLY")
      ) {
        // 현금 결제 대기 상태
        setIsDone(true);

        // 전역상태 확인
        setNavStep(2);
      } else {
        try {
          if (
            (isOciProduct && productKey === "WRAPSODY_ECO") ||
            serviceList?.length === 0
          ) {
            // console.log("여기?", unregisterPromotion?.length);
            try {
              // 카드결제는 했는데 사이트 생성 안된 경우
              console.log("unregisterPay?.length", unregisterPay?.length);
              console.log("unregisterPay", unregisterPay);
              if (unregisterPay?.length > 0) {
                setShowSiteNewModal(true);
                setIsShowPay(false);
                // setServiceList([]);
                setMakeType("MAKE_PAY");
                setNavStep(3);
              }
              // 프로모션 결제는 했는데 사이트 생성 안된 경우
              else if (unregisterPromotion?.length > 0) {
                console.log("2 unregisterPromotion.length > 0");
                console.log("unregisterPromotion", unregisterPromotion);
                setShowSiteNewModal(true);
                setIsShowPay(false);
                // setServiceList([]);
                setMakeType("MAKE_PROMOTION");
                setIsDone(true);

                setNavStep(3);
              } else if (
                unregisterPromotion?.length === 0 &&
                unregisterPay?.length === 0
              ) {
                // 카드결제도 프로모션결제도 안된 경우
                console.log(
                  "카드결제도 프로모션결제도 안된 경우",
                  unregisterPromotion,
                  unregisterPay
                );
                // let makeType = "";
                // 프로모션 결제 체크
                const result = await applyCheckPromotionCode({
                  product: getProductFromSessionStorage(),
                });
                console.log("applyCheckPromotionCode", result);

                if (result) {
                  // 프로모션 결제 체크 결과가 C_REQUEST인 경우 -> 고객이 프리미엄코드 문의 신청한 상태
                  if (["C_REQUEST"].includes(result)) {
                    console.log("C_REQUEST");
                    route.goSitePromotion({});
                  }
                  // 등록 안된 서비스 가 있으면 콘솔로 이동 -> 사이트 생성 (EmptyState)
                  else if (
                    unregisterPay?.length > 0 ||
                    unregisterPromotion?.length > 0
                  ) {
                    console.log("등록 안된 서비스 가 있으면 콘솔로 이동");
                    route.goConsole();
                  } else {
                    setMakeType(result);
                    if (isOciProduct) {
                      if (serviceList?.length > 0) {
                        route.goConsole();
                      } else {
                        route.goSiteType();
                      }
                    } else {
                      route.goSitePromotion({});
                    }
                    // route.goSitePromotion({});
                  }
                } else {
                  // 아무런 결제도 사이트생성도 안된 경우
                  if (isOciProduct) {
                    if (serviceList?.length > 0) {
                      route.goConsole();
                    } else {
                      // OCI제품이면 카드결제 페이지로
                      route.goSiteType();
                    }
                  } else {
                    // 나머지는 프로모션 페이지로
                    console.log(
                      "나머지gg",
                      unregisterPromotion,
                      unregisterPromotion?.length
                    );

                    route.goSitePromotion({});
                  }
                  // 무료사이트 체크 기능인데 지금은 사용 X
                  // if (
                  //   !["WRAPSODY", "DSP", "FIRESIDE"].includes(
                  //     getProductFromSessionStorage()
                  //   )
                  // ) {
                  //   const isGoSiteType = [
                  //     "IMPOSSIBLE",
                  //     "POSSIBLE",
                  //     "EXIST",
                  //     "T_USED",
                  //   ];
                  //   // await checkPromotionTrial({
                  //   //   product: getProductFromSessionStorage(),
                  //   // }).then((result) => {
                  //   //   if (
                  //   //     isGoSiteType.includes(result.status) &&
                  //   //     !isOciProduct
                  //   //   ) {
                  //   //     // window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/type`;
                  //   //     // console.log("isGoSiteType", result);
                  //   //     route.goSiteType();
                  //   //     return;
                  //   //   }
                  //   //   makeType = result.status;
                  //   // });
                  // }
                }
                // 프로모션 결제 체크 결과가 있는 경우
                // let promotionCode = "";
                if (result === "T_APPROVED") {
                  // promotionCode = result.promotionCode;
                  setNavStep(3);
                } else if (result === "T_APPLY") {
                  setNavStep(2);
                } else if (result === "C_APPLY") {
                  setNavStep(2);
                }

                // setServiceList([]);

                // setMakeType(result);
                setIsDone(true);
                // setPromotionCode(promotionCode);
                setDoNotOpenGuide(close30dGuide);
              } else {
                console.log("나머지");
              }
            } catch (error) {
              if (isOciProduct) {
                route.goSiteType();
              } else {
                console.log("catch문");
                route.goSitePromotion({});
              }
            }
          } else {
            let serviceNotice = "";
            // promotion이 있으면 상단 공지사항 뿌려준다.

            if (serviceList && serviceList?.length > 0) {
              serviceNotice = serviceList[0].serviceStatus;
            }

            setIsDone(true);
            setDoNotOpenGuide(close30dGuide);
            // AWS 사이트 생성 시 프로그레스 바 폴링
            if (serviceNotice !== "SERVICE" && !isOciProduct && !isDspProduct) {
              let targetServiceUidLocal = "";
              if (
                Array.isArray(serviceList) &&
                typeof detailIndex === "number" &&
                serviceList[detailIndex] &&
                typeof (serviceList[detailIndex] as any).serviceUid === "string"
              ) {
                targetServiceUidLocal = (serviceList[detailIndex] as any)
                  .serviceUid as string;
              }
              setPollTargetUid(targetServiceUidLocal);
            }
          }
        } catch (error: any) {
          if (error?.errorCode && error?.errorMessage) {
            notifyError(error.errorMessage);
          }
        }
      }
    };

    // 1. 제품 리스트 체크
    // 2. 제품이 없는경우 빈 문자열을 받아온다
    if (!isMyServiceLoading) {
      console.log("isMyServiceLoading", unregisterPay, unregisterPromotion);
      init();
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMyServiceLoading, unregisterPay, unregisterPromotion, productKey]);
}
